<template>
    <base-modal
        class="soy-sauce-modal"
        ref="soySauceModal"
        name="soy-sauce-modal"
        hide-footer
        hide-header
        title="Soy Sauce"
        v-bind="$attrs"
    >
        <h2
            class="title"
            v-test:title
        >
            {{ $snippet('soy_sauce_modal_title', 'itsu customers ‘dip’ in soy sauce, they don’t drink it.') }}
        </h2>

        <markdown-content
            :content="$snippet('soy_sauce_modal_content', '')"
            v-test:content
        />

        <b-button
            variant="primary"
            @click="hideModal"
            v-test:closeBtn
        >
            {{ $snippet('soy_sauce_modal_close_button_text', 'close') }}
        </b-button>
    </base-modal>
</template>

<script>
    import BaseModal from '../../molecules/BaseModal/BaseModal';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'soy-sauce-modal',

        components: { BaseModal, MarkdownContent },

        methods: {
            /**
             * Hide modal.
             */
            hideModal() {
                this.$refs.soySauceModal
                    .$children[0]
                    .hide();
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .modal-body {
        @include media-breakpoint-up(lg) {
            padding: 96px 68px 101px;
        }
    }

    .app-icon {
        width: auto;
        height: 44px;
        color: transparent;
        margin-bottom: 30px;
    }

    .title {
        font-size: rem(30px);
        line-height: 1.2;
        font-weight: bold;
        margin-bottom: 26px;

        @include media-breakpoint-up(lg) {
            font-size: rem(46px);
        }
    }

    .markdown-content {
        margin-bottom: 30px;
        font-size: rem(18px);
        line-height: rem(22.5px);

        @include media-breakpoint-up(lg) {
            font-size: rem(24px);
            line-height: rem(27px);
        }

        ::v-deep img {
            max-width: 100%;
            height: auto;
        }
    }

    .btn {
        min-width: 165px;
    }
</style>
